import { useEffect, useState } from "react";
import useTranslator from "../../hooks/useTranslator";
import { Badge, Button, Icon, Modal } from "../../components/design";
import checkStyles from "./ApplicationCreatedModal.module.css";

// isGuarantor only changed the old overlay background; the shared Modal has
// one backdrop for everyone.
// eslint-disable-next-line no-unused-vars
const KycVerificationPopup = ({ showPopup, onContinue, isGuarantor }) => {
  const { _t } = useTranslator();
  const [isContinuing, setIsContinuing] = useState(false);

  useEffect(() => {
    if (showPopup) setIsContinuing(false);
  }, [showPopup]);

  const handleContinue = async () => {
    if (isContinuing) return;
    setIsContinuing(true);
    try {
      await onContinue?.();
    } finally {
      setIsContinuing(false);
    }
  };

  return (
    <Modal
      open={!!showPopup}
      onClose={handleContinue}
      dismissible={false}
      icon={
        <span className={checkStyles.check}>
          <Icon name="fileText" size={28} />
        </span>
      }
      title={_t("kycIdCheckingTitle")}
      description={_t("kycIdCheckingDescription")}
      actions={
        <Button size="lg" block loading={isContinuing} onClick={handleContinue}>
          {_t("continueToDocuments")}
        </Button>
      }
    >
      <Badge tone="neutral" className={checkStyles.status}>
        {_t("inReview")}
      </Badge>
    </Modal>
  );
};

export default KycVerificationPopup;
